/** @format */

/**
 * Removes a trailing slash from a url
 *
 * @param url The url to remove the trailing slash from
 * @returns {string} The url without the trailing slash
 */
export function removeTrailingSlash(url: string) {
    return url.replace(/\/$/, '');
}
